<template>
  <div class="b-comments-list__heading">
    <div class="b-comments-list__btns">
      <button class="btn button-transparent-red b-comments-list__btn--first" @click.prevent = "showModal">
        Добавить комментарий
      </button>
    </div>
    <div class="b-comments-list__filters">
      <button class="btn button-transparent b-comment-filters__btn" @click.prevent="sortComments('popular')">Популярные</button>
      <button class="btn button-transparent b-comment-filters__btn" @click.prevent="sortComments('date')">По дате</button>
    </div>
  </div>
</template>
<script>
import { bus } from './bus.js'
  export default {
    methods: {
      showModal() {
        this.$root.filtered = true;
        bus.$emit('show-auth-modal');
      },
      sortComments(data){
        this.$root.filtered = true;
        bus.$emit('sort-comments', data);
      }
    }
  }
</script>